module.exports = __webpack_public_path__ + "img/login.5e71ddb4.png";